export const AppFonts = `
@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: bold;
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebBold.eot");
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebBold.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */
      url("https://rebix.ir/_ragc/styles/fonts/woff/IRANYekanWebBold.woff")
      format("woff"),
    /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
      url("https://rebix.ir/_ragc/styles/fonts/woff2/IRANYekanWebBold.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("https://rebix.ir/_ragc/styles/fonts/ttf/IRANYekanWebBold.ttf")
      format("truetype");
}

@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 100;
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebThin.eot");
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebThin.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */
      url("https://rebix.ir/_ragc/styles/fonts/woff/IRANYekanWebThin.woff")
      format("woff"),
    /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
      url("https://rebix.ir/_ragc/styles/fonts/woff2/IRANYekanWebThin.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("https://rebix.ir/_ragc/styles/fonts/ttf/IRANYekanWebThin.ttf")
      format("truetype");
}

@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 300;
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebLight.eot");
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebLight.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */
      url("https://rebix.ir/_ragc/styles/fonts/woff/IRANYekanWebLight.woff")
      format("woff"),
    /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
      url("https://rebix.ir/_ragc/styles/fonts/woff2/IRANYekanWebLight.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("https://rebix.ir/_ragc/styles/fonts/ttf/IRANYekanWebLight.ttf")
      format("truetype");
}

@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: normal;
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebRegular.eot");
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebRegular.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */
      url("https://rebix.ir/_ragc/styles/fonts/woff/IRANYekanWebRegular.woff")
      format("woff"),
    /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
      url("https://rebix.ir/_ragc/styles/fonts/woff2/IRANYekanWebRegular.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("https://rebix.ir/_ragc/styles/fonts/ttf/IRANYekanWebRegular.ttf")
      format("truetype");
}

@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 500;
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebMedium.eot");
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebMedium.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */
      url("https://rebix.ir/_ragc/styles/fonts/woff/IRANYekanWebMedium.woff")
      format("woff"),
    /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
      url("https://rebix.ir/_ragc/styles/fonts/woff2/IRANYekanWebMedium.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("https://rebix.ir/_ragc/styles/fonts/ttf/IRANYekanWebMedium.ttf")
      format("truetype");
}

@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 800;
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebExtraBold.eot");
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebExtraBold.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */
      url("https://rebix.ir/_ragc/styles/fonts/woff/IRANYekanWebExtraBold.woff")
      format("woff"),
    /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
      url("https://rebix.ir/_ragc/styles/fonts/woff2/IRANYekanWebExtraBold.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("https://rebix.ir/_ragc/styles/fonts/ttf/IRANYekanWebExtraBold.ttf")
      format("truetype");
}

@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 850;
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebBlack.eot");
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebBlack.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */
      url("https://rebix.ir/_ragc/styles/fonts/woff/IRANYekanWebBlack.woff")
      format("woff"),
    /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
      url("https://rebix.ir/_ragc/styles/fonts/woff2/IRANYekanWebBlack.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("https://rebix.ir/_ragc/styles/fonts/ttf/IRANYekanWebBlack.ttf")
      format("truetype");
}

@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 900;
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebExtraBlack.eot");
  src: url("https://rebix.ir/_ragc/styles/fonts/eot/IRANYekanWebExtraBlack.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */
      url("https://rebix.ir/_ragc/styles/fonts/woff/IRANYekanWebExtraBlack.woff")
      format("woff"),
    /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
      url("https://rebix.ir/_ragc/styles/fonts/woff2/IRANYekanWebExtraBlack.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("https://rebix.ir/_ragc/styles/fonts/ttf/IRANYekanWebExtraBlack.ttf")
      format("truetype");
}
`;

export const AppStyles = {
  classes: (theme) => {
    return {
      appbarBox: {
        display: "flex",
        alignItems: "center",
        "& img": {
          height: 36,
        },
      },
      primaryPaper: {
        backgroundColor: "#f2f2f2 !important",
      },
      secondaryBackground: {
        backgroundColor: theme.palette.secondary.main,
      },
      secondaryBackgroundFader: {
        backgroundColor: theme.palette.secondaryFader.main,
      },
      textLinkButton: {
        cursor: "pointer",
        "&:hover": {
          color: "#F8C711",
        },
      },
      textCaptions: {
        fontSize: 13,
        textDecoration: "none",
        color: theme.palette.text.primary,
        opacity: "70%",
      },
      linkSecondary: {
        color: theme.palette.text.primary,
        opacity: "50%",
        fontSize: 13,
        textDecoration: "none",
        "&:hover": {
          opacity: "70%",
        },
      },
      effectGlass: {
        background: "rgba(255,255,255,0.1)",
        borderRadius: 7,
        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(4.2px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
      },
      dialogTitle: {
        fontSize: "17px !important",
        fontWeight: "700 !important",
        padding: "20px 24px !important",
      },
      componentsNavbar: {
        padding: "17px 30px 17px",
        margin: 0,
        borderBottomWidth: 1,
        borderBottomStyle: "solid",
        borderBottomColor: theme.palette.secondary.main,
      },
      componentsCarouselAnnouncement: {
        fontSize: 13,
        fontWeight: 500,
        "& a": {
          textDecoration: "none",
          color: theme.palette.text.primary,
          opacity: "70%",
        },
      },
      componentsCarouselAnnouncementFlash: {
        textDecoration: "none",
        color: theme.palette.text.primary,
        opacity: "70%",
      },
      componentsTabBoxedContainer: {
        backgroundColor: theme.palette.secondary.main,
        width: "auto",
        borderRadius: 5,
      },
      componentsTabPanelCoinMain: {
        padding: "0 !important",
      },
      componentsListCoinMain: {
        padding: "0 !important",
        "& .componentsListCoinMainItem": {
          fontSize: 13,
        },
      },
      componentsListItemMainExploreProduct: {
        padding: "18px 10px !important",
        fontSize: 13,
      },
      componentsTextChangeUp: {
        backgroundColor: "rgba(118, 160, 103)",
        width: 65,
        padding: 7,
        textAlign: "center",
        borderRadius: 3,
      },
      componentsTextChangeDown: {
        backgroundColor: "#EA4646",
        width: 65,
        padding: 7,
        textAlign: "center",
        borderRadius: 3,
      },
      backgroundImageLacked: {
        backgroundImage:
          "url('https://rebix.io/_ragc/styles/images/template/shape_rounded_lackbg.svg')",
        backgroundRepeat: "no-repeat",
      },
      componentsShapeWave1: {
        position: "absolute",
        top: 0,
        width: "100%",
        maxWidth: 700,
        overflow: "hidden",
        lineHeight: "0",
        zIndex: -1,
      },
      componentsShapeWave2: {
        position: "absolute",
        top: 0,
        width: "100%",
        maxWidth: 500,
        overflow: "hidden",
        lineHeight: "0",
        transform: "translateX(-50%)",
        zIndex: -1,
      },
      componentsShapeStoreIcon: {
        width: 29,
        height: 29,
        "& svg": {
          fill: theme.palette.text.primary,
        },
      },
      componentsTransactionReceipt: {
        backgroundColor: theme.palette.theme.main,
        boxShadow: "0 0 85px rgb(0 0 0 / 10%)",
      },
    };
  },
  typography: {
    fontFamily: "iranyekan, Roboto",
    button: {
      textTransform: "none",
    },
    navBar: {
      fontFamily: "iranyekan, Roboto",
      fontSize: 13,
      fontWeight: 400,
    },
    title: {
      fontFamily: "iranyekan, Roboto",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 2,
    },
    text: {
      fontFamily: "iranyekan, Roboto",
      fontSize: 13,
      fontWeight: 400,
      lineHeight: 2,
    },
    caption: {
      fontFamily: "iranyekan, Roboto",
      fontSize: 12,
      fontWeight: 500,
      opacity: "60%",
      lineHeight: 2,
    },
    staticWhite: {
      fontFamily: "iranyekan, Roboto",
      fontSize: 12,
      fontWeight: 500,
      color: "#fff",
    },
    h6: {
      fontWeight: 800,
      fontSize: "1.15rem",
    },
    h5: {
      fontWeight: 800,
    },
  },
  palette: {
    light: {
      theme: {
        main: "#fff",
        contrastText: "#000",
      },
      primary: {
        main: "#F8C711",
        contrastText: "#000",
      },
      secondary: {
        main: "#F2F2F2",
        contrastText: "#000",
      },
      secondaryFader: {
        main: "#F9F9F9",
        contrastText: "#000",
      },
    },
    dark: {
      theme: {
        main: "#1c1c1c",
        contrastText: "#fff",
      },
      primary: {
        main: "#F8C711",
        contrastText: "#000",
      },
      secondary: {
        main: "#222222",
        contrastText: "#fff",
      },
      secondaryFader: {
        main: "#191919",
        contrastText: "#fff",
      },
    },
  },
};

export const AppTheme = {
  light: {
    typography: AppStyles.typography,
    palette: {
      textButton: {
        main: "#000",
        contrastText: "#FFF",
      },
      ...AppStyles.palette.light,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: AppFonts,
      },
    },
  },
  dark: {
    typography: AppStyles.typography,
    palette: {
      mode: "dark",
      textButton: {
        main: "#FFF",
        contrastText: "#000",
      },
      ...AppStyles.palette.dark,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: AppFonts,
      },
    },
  },
};
